import { APIError, get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { SoldServiceAppDataModel } from '@user/store/opportunity'

import { SoldServiceAppDataFetchResult as Result } from '../typings'
import { ToTitleCase } from '@user/utils/ToTitleCase'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.opportunity.opportunity}`

type OpportunityAppDataDTO = {
  id: number
  opportunityId: number
  order: number
  key: string | null
  value: string | null
  valueId: string | null
  valueType: SoldServiceAppDataModel['type']
  caption: string | null
}

export async function getSavedAppData(opportunityId: number): Promise<Result> {
  const result: Result = {
    appData: [],
    customFields: {},
  }

  const response = await get(
    `${baseUrl}/${opportunityId}${ServiceConfig.opportunity.appData}`,
  )

  if (response.ok && response.status === 200) {
    const dtos: OpportunityAppDataDTO[] = await response.json()

    // ensure valueType case is correct
    dtos.forEach((d) => {
      d.valueType = ToTitleCase(d.valueType)
    })

    // set removes duplicate values, ensure only the latest are displayed
    const appData = new Map<string, SoldServiceAppDataModel>()

    dtos.map((dto) => {
      if (dto.key === null) return

      const id = dto.key

      if (dto.valueType === 'Dropdown') {
        // convert value type
        result.customFields[id] = dto.valueId ?? ''

        // add values array
        appData.set(id, {
          id,
          caption: dto.caption ?? '',
          required: false,
          type: dto.valueType,
          values: [{ id: dto.valueId ?? '', name: dto.value ?? '' }],
        })
      } else {
        // convert value type
        if (dto.valueType === 'Boolean') {
          result.customFields[id] = dto.value === 'true'
        } else if (dto.valueType === 'Date') {
          result.customFields[id] = dto.value === '' ? null : dto.value
        } else {
          result.customFields[id] = dto.value
        }

        appData.set(id, {
          id,
          required: false,
          type: dto.valueType,
          caption: dto.caption ?? '',
        })
      }
    })

    result.appData = [...appData.values()]
  } else if (!response.ok) {
    const error = (await response.json()) as APIError
    throw error.Message
  }

  return result
}
